export const PCP_ONLY_FIELDS = [
  'Unvaccinated-Children',
  'ADD-ADHD',
  'Chronic-Pain-Management',
  'Pap',
  'OB-Visits',
  'Disability-Physical',
  'Military-Physical',
  'Flight-Physical',
  'DOT-Physical',
  'Immigration-Physical',
  'Takes-Walk-Ins',
  'Next-In-Line',
  'Medicare-Wellness',
  'Additional-Treatments-Offered',
  'Type-Of-Schedule',
  'Cross-Coverage-Sick',
  'Cross-Coverage-for-Sick-Market',
  'Closest-Urgent-Care',
];

export const SPECIALIST_ONLY_FIELDS = [
  'Provider-Referral-Required',
  'HMO-LT3D-Request',
  'Auto-Accident-Related-Injuries',
  'Same-Day',
  'Virtual-Waiting-Room',
  'Procedures-Surgeries',
  'Conditions-Treated',
  'Conditions-Not-Treated',
  'Cross-Coverage',
  'Telehealth',
  'Triage-Triggers',
  'Facilities-Used',
  'Patients-Virtual-Waiting-Schedule',
  'Scheduling-Notes',
];

export const BOTH_FIELDS = [
  'Age',
  'New-Patient',
  'New-Telehealth',
  'Other-Languages',
  'Out-Of-State-Telehealth',
  'Workers-Comp',
  'Supervision-Physician',
  'State-Specific-Limitations',
  'Provider-Group',
  'Hospital-Backline',
  'Cross-Schedule-Hospital-Follow-Up',
  'Office-Notes',
  'Daily-Alert',
  'Additional-Location-Days',
];

/**
 * PCP coverage fields stored as complex custom fields (value + metadata such as
 * linked providers/clinics). They are excluded from the generic field columns
 * and rendered in the dedicated "Scheduling & Coverage" section instead.
 */
export const PCP_COVERAGE_COMPLEX_FIELDS = [
  'Cross-Coverage-Sick',
  'Cross-Coverage-for-Sick-Market',
  'Closest-Urgent-Care',
];
